/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyFormValidationData
 */
export interface AgencyFormValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AgencyFormValidationData
     */
    effectiveDates?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AgencyFormValidationData
     */
    abtaNumber?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AgencyFormValidationData
     */
    label?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AgencyFormValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AgencyFormValidationData
     */
    inconsistentState?: ValidationMessage;
}

export function AgencyFormValidationDataFromJSON(json: any): AgencyFormValidationData {
    return AgencyFormValidationDataFromJSONTyped(json, false);
}

export function AgencyFormValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyFormValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'effectiveDates': !exists(json, 'effectiveDates') ? undefined : ValidationMessageFromJSON(json['effectiveDates']),
        'abtaNumber': !exists(json, 'abtaNumber') ? undefined : ValidationMessageFromJSON(json['abtaNumber']),
        'label': !exists(json, 'label') ? undefined : ValidationMessageFromJSON(json['label']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'inconsistentState': !exists(json, 'inconsistentState') ? undefined : ValidationMessageFromJSON(json['inconsistentState']),
    };
}

export function AgencyFormValidationDataToJSON(value?: AgencyFormValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'effectiveDates': ValidationMessageToJSON(value.effectiveDates),
        'abtaNumber': ValidationMessageToJSON(value.abtaNumber),
        'label': ValidationMessageToJSON(value.label),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'inconsistentState': ValidationMessageToJSON(value.inconsistentState),
    };
}


